import { render, staticRenderFns } from "./FollowUpAndTaskTable.vue?vue&type=template&id=18b2405c&scoped=true"
import script from "./FollowUpAndTaskTable.vue?vue&type=script&lang=ts"
export * from "./FollowUpAndTaskTable.vue?vue&type=script&lang=ts"
import style0 from "./FollowUpAndTaskTable.vue?vue&type=style&index=0&id=18b2405c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b2405c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18b2405c')) {
      api.createRecord('18b2405c', component.options)
    } else {
      api.reload('18b2405c', component.options)
    }
    module.hot.accept("./FollowUpAndTaskTable.vue?vue&type=template&id=18b2405c&scoped=true", function () {
      api.rerender('18b2405c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/FollowUpAndTaskTable.vue"
export default component.exports